var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHourglass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 56,
    viewBox: "0 0 66 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10742_3266)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0833 10.3896H49.9166L48.1666 13.8896H17.8333L16.0833 10.3896Z",
    fill: "#966235"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8333 41.584H48.1666L49.9166 45.084H16.0833L17.8333 41.584Z",
    fill: "#966235"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.3333,
    y: 6.30615,
    width: 37.3333,
    height: 4.31667,
    rx: 1.40001,
    fill: "#AF7442"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.3333,
    y: 44.8496,
    width: 37.3333,
    height: 4.31667,
    rx: 1.40001,
    fill: "#AF7442"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4584 14.166H47.5983C47.5983 19.416 40.078 24.0827 35.5908 28.166C40.078 32.2493 47.9046 36.3115 47.9046 41.5615H18.1674C18.1674 36.3115 26.6165 32.2493 31.1036 28.166C26.6165 24.0827 18.4584 19.416 18.4584 14.166Z",
    fill: "url(#paint0_linear_10742_3266)",
    stroke: "#AF7442",
    strokeOpacity: 0.55,
    strokeWidth: 0.613142
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.93 35.166H38.5966C42.0966 37.4993 47.7509 39.3577 47.7509 41.691L18.7633 41.5827C18.7633 39.2493 23.43 37.4993 26.93 35.166Z",
    fill: "#FFCA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1802 25.8327C32.1802 25.1884 32.7026 24.666 33.3469 24.666C33.9912 24.666 34.5136 25.1884 34.5136 25.8327V33.9993C34.5136 34.6437 33.9912 35.166 33.3469 35.166C32.7026 35.166 32.1802 34.6437 32.1802 33.9993V25.8327Z",
    fill: "#FFCA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.597 28.1663L25.9847 23.5836L40.6603 23.5835L35.0285 28.2409L31.597 28.1663Z",
    fill: "#FFCA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10742_3266",
    x1: 42.6804,
    y1: 25.8327,
    x2: 21.6804,
    y2: 26.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.322115,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855769,
    stopColor: "#FFF8C1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10742_3266"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 43.1667,
    fill: "white",
    transform: "translate(12 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglass);
export default __webpack_public_path__ + "static/media/hourglass.09eaa935f8f2db77322454736f30bcf4.svg";
export { ForwardRef as ReactComponent };